module.exports = __webpack_public_path__ + "img/plan-2.615a29b6.png";